document.addEventListener('DOMContentLoaded', function() {

  const observer = new MutationObserver((mutationsList, observer) => {
    // 1. Buscamos el contenedor principal que aloja el Shadow DOM
    const hostElement = document.querySelector('gty-whatsapp-chat-button');
    
    // 2. Si el host existe y su shadowRoot ya fue creado
    if (hostElement && hostElement.shadowRoot) {
        // 3. Buscamos la clase específica DENTRO del Shadow DOM
        const whatsappLink = hostElement.shadowRoot.querySelector(".gty-wacb-wrapper");
        
        if (whatsappLink) {
          console.log('Elemento con clase "gty-wacb-wrapper" detectado en el Shadow DOM');
          
          whatsappLink.addEventListener("click", () => {
            console.log("Clic en WhatsApp detectado");
            if (typeof gtag === "function") {
              gtag("event", "adw_click_whatsapp");
            }
            if (typeof fbq === "function") {
              fbq("track", "Contact", { content_name: "whatsapp" });
            }
          });
          
          observer.disconnect(); // Detenemos la observación una vez encontrado
        }
    }
  });

  // jQuery is not loaded
  console.log("without jquery load");

  /**
   * Activacion e incrustación de clases para eventos
   */
  /*
  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_phone");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });
  */
  const phoneMap = {
    "3336541811": "guadalajara",
    "3336542092": "guadalajara",
    "4422092300": "queretaro",
    "4421670426": "irapuato",
    "8124737850": "monterrey",
    "8124737869": "monterrey",
    "8447981099": "saltillo",
    "8717171922": "torreon",
    "6642500187": "tijuana",
    "8008388861": "nacional"
  };

  document.querySelectorAll('a[href^="tel"]').forEach((element) => {

    const phone = element.getAttribute("href")
      .replace("tel:", "")
      .replace(/\D/g, "");

    const city = phoneMap[phone] || "otro";

    element.dataset.city = city;
    element.classList.add("link-phone");
    element.setAttribute("target", "_blank");

    element.addEventListener("click", function () {

      const city = this.dataset.city;

      if (typeof gtag === "function") {
        gtag("event", "adw_click_phone", { city });

        if (city !== "otro") {
          gtag("event", `adw_phone_${city}`);
        }
      }

      if (typeof fbq === "function") {
        fbq("track", "Contact", {
          content_name: `telefono_${city}`
        });
      }

    });

  });

  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_email");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="maps.google"]').forEach((element) => {
    element.classList.add("link-map");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_map");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "maps" });
      }
    });
  });
})
